import { Component, OnInit, ViewChild } from '@angular/core';
import { ScrBaseComponent } from '../../../base.component';
import { AccountAndUser } from 'src/app/models/account.model';
import { AccountService } from 'src/app/services';
import { TableColumn } from 'src/app/models/table-columns';
import { LinkedAccountsNavigatorComponent } from '../linked-accounts-navigator/linked-accounts-navigator.component';

@Component({
  templateUrl: './linked-accounts-list.component.html'
})
export class LinkedAccountsListComponent extends ScrBaseComponent implements OnInit {

  public accounts!: AccountAndUser[];
  public displayCreateNewLinkedAccount = false;

  public tableColumn: TableColumn[] = [
    { field: 'account.linkedAccountName', sort: true, localizationKey: 'accountName' },
    { field: 'account.accountId', sort: true, localizationKey: 'accountId' },
    { field: 'phone' },
    { field: 'email' }
  ];

  @ViewChild(LinkedAccountsNavigatorComponent) navigator!: LinkedAccountsNavigatorComponent;

  constructor(private accountService: AccountService) {
    super();
  }

  ngOnInit(): void {
    this.localizeTableColumns(this.tableColumn);

    this.observe(this.accountService.getLinkedAccounts(), rsp => {
      this.accounts = rsp.accounts;
      return false;
    });
  }

  loginAs(accountAndUser: AccountAndUser): void {
    if (accountAndUser.account?.accountId) {
      this.navigator.loginAs(accountAndUser.account?.accountId);
    }
  }

  createNewLinkedAccount(): void {
    this.displayCreateNewLinkedAccount = true;
  }

  protected override hideChildren(): void {
    this.displayCreateNewLinkedAccount = false;
  }

  protected override reloadList(message?: string, messageCode?: string): void {
    this.observe(this.accountService.getLinkedAccounts(), rsp => {
      this.accounts = rsp.accounts;
      if (messageCode) {
        this.displayLocalizedSuccess(messageCode);
      }
      else if (message) {
        this.displaySuccess(message, true);
      }
      return false;
    });
  }

}
